module.exports = __webpack_public_path__ + "img/imagenotfound.7943178c.png";